<template>
    <common-widget>
        <common-widget-header
            v-if="!$auth.isPracticeAncillary()"
            :heading="$t('elements.home.rating.heading.professional.heading')"
            :hint="$t('elements.home.rating.heading.professional.info')"
        ></common-widget-header>
        <common-widget-header v-else :heading="$auth.getPractice().name"></common-widget-header>
        <common-widget-content :isCenter="true">
            <common-ancillary-avatar
                v-if="$auth.isPracticeAncillary()"
                :ancillary="$auth.getPractice()"
                size="member-switch"
            ></common-ancillary-avatar>
            <common-rating-pie v-if="!$auth.isPracticeAncillary()" :rating="professionalRating"></common-rating-pie>
        </common-widget-content>
        <complete-profile-reminder v-if="showProfileReminder" class="complete-profile-reminder"></complete-profile-reminder>
        <register-practice-reminder v-if="showPracticeReminder" class="complete-profile-reminder"></register-practice-reminder>
        <select-tests-reminder v-if="displayAncillaryServicesTestsReminder" class="select-tests-reminder"></select-tests-reminder>
        <common-widget-header
            class="widget__pt-35"
            :heading="$t('elements.home.rating.heading.medmatch.heading')"
            :hint="$t('elements.home.rating.heading.medmatch.info')"
        ></common-widget-header>

        <common-widget-content :isCenter="true">
            <common-rating-stars :rating="rating"></common-rating-stars>
        </common-widget-content>
    </common-widget>
</template>

<script>
    import CompleteProfileReminder from './profile/CompleteProfileReminder'
    import RegisterPracticeReminder from './practice/RegisterPracticeReminder'
    import SelectTestsReminder from './profile/SelectTestsReminder'
    import UserRolesEnum from '../../enums/UserRolesEnum'
    import PracticeTypeEnum from '@/enums/PracticeTypeEnum'

    export default {
        components: {
            CompleteProfileReminder,
            SelectTestsReminder,
            RegisterPracticeReminder,
        },

        props: {
            professionalRating: { type: [String, Number], default: undefined },
            rating: { type: [String, Number], default: undefined },
        },

        data() {
            return {
                displayAncillaryServicesTestsReminder: false,
            }
        },

        computed: {
            showProfileReminder() {
                const userRoleId = this.$auth.getUser().userRole?.id
                if (
                    !this.$auth.getActiveMember()?.isProfileComplete &&
                    (userRoleId === UserRolesEnum.PHYSICIAN.ID || userRoleId === UserRolesEnum.OFFICE_MANAGER.ID)
                ) {
                    return true
                }
                return false
            },
            showPracticeReminder() {
                return this.$auth.isUserPracticeOther() && (!this.$auth.getPractice() || !this.$auth.getPractice().id)
            },
        },

        methods: {
            getAncillaryServicesByLocation() {
                // +1 because of main location isn't in locations array
                const locationsLength = this.$auth.getPractice().locations.length + 1
                this.displayAncillaryServicesTestsReminder = this.$auth.getFacilityServicesByLocation().some((service) => {
                    return service.practiceTypesSubgroups.length < locationsLength
                })
            },
        },

        mounted() {
            const practice = this.$auth.getPractice()
            if (practice.practiceType === PracticeTypeEnum.ANCILLARY) {
                this.getAncillaryServicesByLocation()
            }
        },
    }
</script>
